const data = [
  {
    id: 0,

    name: "Eduard Danylko",
    title: "We were looking for Gatsby.JS expert to build a new home page ❤️",
    text: " I was very pleased to work with Enrique. He is a very nice person and works well. I advise everyone to work with him in the future. Thanks.",
  },
  {
    id: 1,

    name: "Marisa Obregón",
    title: "Quería el desarrollo de un sitio sencillo y que fuera muy rápido",
    text: "Enrique me aconsejó utilizar Gatsby para el desarrollo de mi sitio, el resultado fue sorprendente. El programador estuvo atento a mis necesidades y las supo plasmar en mi web.",
  },
];

export default data;
